export default __webpack_public_path__ + "static/media/walletIcon4.3e5f5901.png";